import React, { useState, useEffect, useCallback } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { OVERVIEW } from "../mock";

export default function Overview() {
  const [idx, setIdx] = useState(0);
  const count = OVERVIEW.slides.length;

  const next = useCallback(() => setIdx((i) => (i + 1) % count), [count]);
  const prev = () => setIdx((i) => (i - 1 + count) % count);

  useEffect(() => {
    const t = setInterval(next, 4500);
    return () => clearInterval(t);
  }, [next]);

  return (
    <section id="overview" className="section-pad bg-white">
      <div className="container mx-auto px-4 max-w-[1200px]">
        <div className="site-heading text-center max-w-[820px] mx-auto mb-14">
          <h4>Über uns</h4>
          <h2>{OVERVIEW.heading}</h2>
          <p>{OVERVIEW.text}</p>
        </div>

        <div className="relative max-w-[1000px] mx-auto">
          <div className="overflow-hidden rounded-2xl shadow-2xl border border-slate-100">
            <div
              className="flex transition-transform duration-700 ease-out"
              style={{ transform: `translateX(-${idx * 100}%)` }}
            >
              {OVERVIEW.slides.map((s, i) => (
                <div key={i} className="min-w-full">
                  <img
                    src={s}
                    alt={`Screenshot ${i + 1}`}
                    className="w-full h-[300px] md:h-[520px] object-cover"
                  />
                </div>
              ))}
            </div>
          </div>

          {/* Arrows */}
          <button
            className="car-arrow absolute left-3 top-1/2 -translate-y-1/2 md:-left-6"
            onClick={prev}
            aria-label="Zurück"
          >
            <ChevronLeft size={22} />
          </button>
          <button
            className="car-arrow absolute right-3 top-1/2 -translate-y-1/2 md:-right-6"
            onClick={next}
            aria-label="Weiter"
          >
            <ChevronRight size={22} />
          </button>

          {/* Dots */}
          <div className="flex items-center justify-center gap-2 mt-7">
            {OVERVIEW.slides.map((_, i) => (
              <button
                key={i}
                className={`dot ${i === idx ? "active" : ""}`}
                onClick={() => setIdx(i)}
                aria-label={`Slide ${i + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
